module.exports = __webpack_public_path__ + "static/media/exim-icon.e5c7de74.png";